<template>
  <div>
    <page-title>View Poll</page-title>

    <section-block>
      <template #header>
        <h2>View Poll</h2>
      </template>
      <template #actions>
        <base-button icon-before="back" @click="gotoPolls"
          >Back to polls</base-button
        >
      </template>
      <p>
        Please note you can only view the poll here, you will not be able to
        submit an entry.
      </p>
      <form-poll :showValidTick="false" placeholder :poll="id" />
    </section-block>
  </div>
</template>

<script>
export default {
  name: "ViewPoll",

  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  methods: {
    gotoPolls() {
      this.$router.push({ name: "AdminPollsIndex" });
    },
  },
};
</script>

<style lang="scss" scoped></style>
